import React from 'react';
import classNames from 'classnames';
import styles from './facebook-apps.module.scss';

import { MetaIcon } from '../../icons';

const FacebookApps: React.FunctionComponent<{
  className?: string;
}> = ({
  className,
}) => {
  return (
    <a
      className={classNames(
        styles.component,
        className,
      )}
      href="https://www.facebook.com/Meta/"
      title="Meta"
    >
      <MetaIcon
        className={classNames(styles.logo)}
      />
    </a>
  );
}

export default FacebookApps;
